angular.module('impactx.vcatalog').controller('VCatalogEditCtrl', VCatalogEditController);
VCatalogEditController.$inject = [
    '$scope',
    '$sce',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    '$config',
    'TranslationService',
    'ToolbarService',
    'ToastService',
    'WarningService',
    'AppConfiguration',
    '$mdDialog'
];

function VCatalogEditController($scope, $sce, dataGen, $routeParams, BackService, $mdToast, $config, TranslationService, ToolbarService,
                                ToastService, WarningService, AppConfiguration, $mdDialog) {
    var enablePRGDialog = AppConfiguration.get('enableCatalogToViewCopy');

    var self = this;
    dataGen.getData($scope, {id: $routeParams.id}, "/vcatalog/edit").then(function () {
        if ($scope.data.vcat.creator == 8) {
            $scope.trns.catalog = TranslationService.get('themeWorld');
        }
        else {
            $scope.trns.catalog = TranslationService.get('catalog');
        }
        $scope.trns[6] = $sce.trustAsHtml($scope.trns[6]);
        defineButtons();
    });

    self.save = function () {
        var scope = {};

        return dataGen.postAsForm(scope, {
            id: $scope.data.vcat.id,
            vcat: $scope.data.vcat
        }, "/vcatalog/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent(scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    self.getCatalogEntries = function (id, searchText) {
        return dataGen.getData({}, {
            id: id,
            query: searchText
        }, "/vcatalog/get/catalogs", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    self.getCompanyEntries = function (id, searchText) {
        return dataGen.getData({}, {
            id: id,
            query: searchText
        }, "/vcatalog/get/owningcompanies", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    self.delete = function () {
        return dataGen.postAsForm({}, {
            id: $scope.data.vcat.id
        }, "/vcatalog/delete").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    self.deleteDialog = function (event) {
        if ($scope.data.vcat.catalog && $scope.data.vcat.catalog.id > 0) {
            var warnings = [$scope.trns.deleteCatToo];
            WarningService.showWarningDialog(self.delete, event, $scope.trns.warning, TranslationService.get('ok'),
                TranslationService.get('abort'), warnings, event);
        }
        else
        {
            self.delete();
        }
    };

    self.updatePriceGroupData = function (selected) {
        if (selected) {
            dataGen.getData({}, {vcatId: $routeParams.id, psgMatchCode: selected.id}, "/vcatalog/updatePriceGroupData").then(function (data) {
                $scope.data.vcat.lastDatePriceGroup = data.data.lastDatePriceGroup;
            });
        }
    };

    $scope.tinymceOptions = $config.tinymceOptions;

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.productGroups,
                type: 'link',
                linkFunction: getPRGDialogLink,
                condition: canUsePRGDialog
            },
            {
                label: $scope.trns.extendLastDate,
                action: self.extendLastDate,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data && $scope.data.vcat && $scope.data.vcat.canExtendLastDate
                        && $scope.data.vcat.priceGroup && $scope.data.vcat.priceGroup.selected && $scope.data.vcat.priceGroup.selected.id
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function getPRGDialogLink() {
        return 'editvcatproductgroups/' + $routeParams.id;
    }

    function canUsePRGDialog() {
        return enablePRGDialog && !$scope.data.readOnly && $scope.data.vcat.enableProductGroupDialog;
    }

    function canDelete() {
        return !$scope.data.readOnly && $scope.data.vcat.id > 0;
    }

    self.extendLastDate = function (event) {
        return $mdDialog.show({
            controller: "ExtendCatalogLastDateCtrl",
            controllerAs: "extendCatalogLastDateCtrl",
            templateUrl: "modules/catalog/templates/catalogextendlastdate.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                trns: $scope.trns,
                newLastDateProduct: $scope.data.vcat.lastDateProduct
            }
        }).then(function (newLastDateProduct) {
            $scope.data.vcat.newLastDateProduct = newLastDateProduct;
            dataGen.postAsForm({}, {vcat: $scope.data.vcat}, "/vcatalog/extendlastdate").then(function (result) {
                BackService.back();
                ToastService.openStandardToast(result.trns.extendSuccess);
            });

        });
    };

    self.updateLastDatePrice = function () {
        if (impactX.isDefined($scope, 'data.vcat.priceGroup.selected')) {
            dataGen.getData({}, {vcatId: $routeParams.id, psgMatchCode: $scope.data.vcat.priceGroup.selected.id}, "/vcatalog/lastedateprice").then(function (data) {
                $scope.data.vcat.lastDateProduct.dateValue = data.data.lastDateProduct.dateValue;
            });
        }

    }
}
